import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useProjects } from '../../hooks/useProjects';
import ProjectsDashboard from '../../components/administracion/ProjectsDashboard';

const ProyectosPage = () => {
  const { projects, error, isLoading } = useProjects();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar proyectos.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <ProjectsDashboard
        windows={projects}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de proyectos:', newOrder);
        }}
      />
    </Box>
  );
};

export default ProyectosPage;